export const CHANGE_LANGUAGE = "@@SETTINGS/CHANGE_LANGUAGE";

export const actionCreators = {
    changeLanguage: (payload) => ({
        type: CHANGE_LANGUAGE, 
        payload
    }),
}

 
